<template>
  <p>Information Request</p>
</template>

<script>
export default {};
</script>

<style scoped>
</style>